import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'camtl-administration',
  templateUrl: './administration.component.html',
  host: { 'class': 'router-outlet' },
  // styleUrls: ['./administration.component.scss']
})
export class CamtlAdministrationComponent implements OnInit {

  constructor(public router: Router) { }

  ngOnInit() {
  }

}
